import styled from "styled-components";
import { defaultTheme } from "styles/theme/default";

export const SidebarWrapper = styled.div`
    position: fixed;
    margin-top: 32px;
    height: 100vh;
    background-color: #FFF;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 35;
    display: flex;
    flex-direction: column;

    /* Força estado colapsado por padrão para evitar flash */
    width: 80px;

    @media screen and (max-width: 820px) {
        width: 0px;
    }

    /* Estado de loading - força sidebar colapsado durante inicialização */
    &.sidebar-loading {
        width: 80px !important;

        .ps-sidebar-container {
            width: 80px !important;
            transition: none !important; /* Remove transições durante loading */
        }

        /* Esconde o texto dos menus durante o loading */
        .menu {
            opacity: 0;
            transition: none !important; /* Remove transições durante loading */
        }

        /* Força todos os elementos internos a não terem transição */
        * {
            transition: none !important;
        }

        @media screen and (max-width: 820px) {
            width: 0px !important;

            .ps-sidebar-container {
                width: 0px !important;
            }
        }
    }

    .ps-sidebar-container {
        background-color: #FFF !important;
    }

    .line {
        width: 40px;
        border: 1px solid #C4C4C4;
        margin: 24px auto;
        transition: width 350ms;
    }

    :hover .line {
        width: 160px;
    }

    .sidebarContainer {
        border: none;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #FFF;
    }

    /* Menu principal */
    .menu {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding-top: 50px;
        padding-bottom: 100px;
        background-color: #FFF;
        opacity: 1;
        transition: opacity 0.3s ease;
    }

    /* Itens do menu e submenus */
    .menuItem, .submenuItem {
        color: ${defaultTheme.colors['gray-300']};
        font-size: 1rem;
        padding: 0;
        background: none !important;
    }

    /* Texto do menu */
    .menuText {
        color: ${defaultTheme.colors['gray-300']};
        font-size: 0.9rem !important;
        transition: color 125ms;
    }

    /* Ícones */
    .menuIcon {
        color: #A2A2A2 !important;
        transition: color 125ms;
    }

    /* Altura padrão dos itens */
    .ps-menu-button, .pro-menu-item {
        height: 40px !important;
        position: relative !important;
    }

    /* Barra lateral (indicador) */
    .ps-menu-button::before, .menuItem::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 4px;
        background-color: transparent;
        transition: all 125ms !important;
    }

    /* Estados hover */
    .ps-menu-button:hover {
        background-color: ${defaultTheme.colors['base-light']} !important;
    }

    .ps-menu-button:hover::before, .menuItem:hover::before {
        background-color: ${defaultTheme.colors['base-dark']} !important;
    }

    .ps-menu-button:hover span,
    .ps-menu-button:hover svg,
    .menuItem:hover .menuText,
    .menuItem:hover .menuIcon {
        color: ${defaultTheme.colors['base-dark']} !important;
        transform: translateY(-1px) !important;
    }

    .ps-menu-button:hover img {
        filter: brightness(0) saturate(100%) invert(45%) sepia(57%) saturate(315%) hue-rotate(39deg) brightness(93%) contrast(87%) !important;
    }

    /* Animação de hover para submenus */
    .ps-submenu-root .ps-menu-button:hover span,
    .ps-submenu-root .ps-menu-button:hover svg,
    .ps-submenu-root .ps-menu-button:hover img {
        transform: translateY(-1px) !important;
        color: ${defaultTheme.colors['base-dark']} !important;
    }

    /* Ícone de expansão dos submenus */
    .ps-submenu-expand-icon {
        color: ${defaultTheme.colors['gray-300']} !important;
        transition: color 125ms !important;
        margin-bottom: 6px;
    }


    /* Título dos submenus */
    .submenuTitle {
        font-size: 0.9rem;
        font-weight: 600;
        color: ${defaultTheme.colors['gray-300']};
    }

    /* Estados active */
    .menuItem.active:not(.submenuItem),
    .ps-menu-button:has(.submenuTitle.active) {
        background-color: ${defaultTheme.colors['base-light']} !important;
    }

    .menuItem.active::before,
    .ps-menu-button.active::before,
    .ps-menu-button:has(.submenuTitle.active)::before {
        background-color: ${defaultTheme.colors['base-dark']} !important;
    }

    .menuItem.submenuItem.active::before {
        background-color: transparent !important;
    }

    .menuItem.active .menuText,
    .menuItem.active .menuIcon,
    .ps-menu-button.active span,
    .ps-menu-button.active .menuIcon,
    .menuIcon.active,
    .ps-menu-button:has(.submenuTitle.active) span {
        color: ${defaultTheme.colors['base-dark']} !important;
    }

    /* Estilo para imagens no estado active */
    .menuItem.active img,
    .ps-menu-button.active img,
    .ps-menu-button:has(.submenuTitle.active) img,
    .menuIcon.active img {
        filter: brightness(0) saturate(100%) invert(45%) sepia(57%) saturate(315%) hue-rotate(39deg) brightness(93%) contrast(87%) !important;
    }

    .submenuItem.active {
        background: none !important;
    }

    .submenuItem.active .menuText,
    .submenuItem.active span {
        color: ${defaultTheme.colors['base-dark']} !important;
    }

    @media screen and (max-height: 1024px) {
        .menu {
            padding-top: 35px;
            padding-bottom: 80px;
        }

        .menuItem .menuText {
            font-size: 0.9rem;
        }

        .menuItem a {
            height: 40px;
        }
    }
`
